import { ElementInventoryStatus } from '@/redux/slices/slice_types';

export enum StatusFilter {
  Ready = 'ready',
  Pending = 'pending',
  Attention = 'attention'
}

export const elementStatusToFilterStatusMap: Record<ElementInventoryStatus, StatusFilter> = {
  [ElementInventoryStatus.Available]: StatusFilter.Ready,
  [ElementInventoryStatus.Pending]: StatusFilter.Pending,
  [ElementInventoryStatus.InProgress]: StatusFilter.Pending,
  [ElementInventoryStatus.Unavailable]: StatusFilter.Pending,
  [ElementInventoryStatus.Missing]: StatusFilter.Pending,
  [ElementInventoryStatus.Error]: StatusFilter.Attention
};

export const statusFilterToElementStatusesMap = Object.entries(elementStatusToFilterStatusMap).reduce<Record<StatusFilter, ElementInventoryStatus[]>>(
  (acc, [elementInventoryStatus, statusFilter]) => {
    acc[statusFilter].push(elementInventoryStatus as ElementInventoryStatus);
    return acc;
  },
  {
    [StatusFilter.Ready]: [],
    [StatusFilter.Pending]: [],
    [StatusFilter.Attention]: []
  }
);
